import $ from 'jquery';

export default () => {
    $('.welcome')
        .on('click', '.welcome__close', (ev) => {
            ev.preventDefault();

            var $welcome = $(ev.delegateTarget),
                $user = $('.user-profile'),
                timeout;

            if ($welcome.data('key') == 'dashboard') {

                $welcome.slideUp(500, function() {
                    if ($welcome.data('trigger-pro-tips')) {
                        $('.pro-tips__trigger').trigger('click');
                    }
                });

                $.ajax({
                    url: '/users/' + $user.data('user-id') + '/welcomes/' + $welcome.data('key'),
                    method: 'DELETE',
                    complete: function() {
                        $welcome.remove();
                    }
                });

            } else {
                $.ajax({
                    url: '/users/' + $user.data('user-id') + '/welcomes/' + $welcome.data('key'),
                    method: 'DELETE',
                    complete: function() {
                        $welcome.remove();
                    }
                });
            }
        })
        .on('click', '.welcome__frame__previous, .welcome__frame__next', function(ev) {
            ev.preventDefault();

            var $me = $(ev.target),
                $welcome = $(ev.delegateTarget),

                $frames = $welcome.find('.welcome__frame'),
                $my_frame = $me.parents('.welcome__frame'),
                my_index = $frames.index($my_frame),

                width = $welcome.outerWidth(),

                direction = $me.hasClass('welcome__frame__previous') ? 'back' : 'forward',
                incoming_index = direction == 'forward' ? my_index + 1 : my_index - 1,
                $incoming_frame = $frames.eq(incoming_index),

                outgoing_x = direction == 'forward' ? 0 - width : width,
                incoming_x = direction == 'forward' ? width : 0 - width;

            $incoming_frame
                .addClass('is-active')
                .css('left', 'incoming_x');

            $my_frame.animate({ left: outgoing_x }, 1000);

            $incoming_frame.animate({ left: 0 }, 1000, function() {
                $my_frame.removeClass('is-active');
            });
        });
}
